export function dynamicsSourceHref(source) {
  const id = source.taskId || source.recordId;
  if (source.type === 'odoo_task' && Number.isSafeInteger(id)) {
    const taskPaths = new Set(['/dashboard/client-testing','/dashboard/ticket-situation','/dashboard/milestone-stories']);
    const path = taskPaths.has(source.path) ? source.path : `/dashboard/${source.test ? 'client-testing' : 'ticket-situation'}`;
    return `${path}?openRecord=${id}`;
  }
  const routes = {helpdesk_ticket:'tickets',deployments:'deploiements',versions:'livraisons'};
  if (routes[source.type] && Number.isSafeInteger(id)) return `/dashboard/${routes[source.type]}?openRecord=${id}`;
  if (source.type === 'documentation' && source.anchor) {
    const params = new URLSearchParams({section:source.anchor,version:source.selectedVersion || 'latest',mode:source.mode || 'functional'});
    if (source.documentationId) params.set('document',source.documentationId);
    return `/dashboard/documentation?${params}`;
  }
  return null;
}
